/**
 * pl-cart-quantity-input.js
 * ------------------------------------------------------------
 * Permite digitar a quantidade diretamente no carrinho (alem dos
 * botoes +/-). Ao confirmar (Enter ou blur), define a quantidade
 * exata via /cart/change.js e sincroniza a UI reaproveitando os
 * metodos publicos do proprio <cart-component> do tema.
 *
 * Descobertas validadas ao vivo (nao mexer sem re-testar):
 *   - Os botoes +/- leem a quantidade de data-quantity (atributo),
 *     NAO do texto exibido -> trocar o span por input e seguro.
 *   - cart-component.updateUI(cart) -> atualiza PIX / subtotal / totais
 *     (nao mexe no input de quantidade, seguro chamar sempre).
 *   - cart-component.renderCartItems(cart) redesenha a linha do item
 *     usando o TEMPLATE INTERNO DO BUNDLE, que sempre desenha um
 *     <span> no lugar do nosso <input> — isso troca o no do DOM e a
 *     segunda edicao para de funcionar (o elemento deixa de ser input).
 *     Por isso NAO chamamos renderCartItems no nosso proprio fluxo de
 *     digitacao: a quantidade exibida e o data-quantity sao atualizados
 *     manualmente, preservando o nosso <input> editavel.
 *   - PORÉM: o bundle guarda a quantidade numa variavel interna
 *     PROPRIA (memoria do componente), separada do atributo
 *     data-quantity do HTML. Quando o cliente digita um valor e
 *     atualizamos so o atributo, a TELA fica certa mas a MEMORIA do
 *     bundle fica desatualizada — ao clicar em +/- depois, o bundle
 *     usa a memoria dele (errada), causando divergencia visivel (ex:
 *     digitou 5, clicou em "-", o bundle calcula a partir do valor
 *     antigo e mostra um numero errado). Por isso este arquivo assume
 *     o controle TOTAL dos botoes +/- tambem (nao so do campo de
 *     texto): impedimos o clique de chegar no bundle (capture +
 *     stopPropagation) e processamos +/- nos mesmos, sempre a partir
 *     do data-quantity atual, nossa unica fonte de verdade.
 *   - O contador do header usa uma string localizada que NAO vem no
 *     JSON cru do /cart.js, entao ele e atualizado manualmente aqui.
 *   - O aviso de minimo, o botao de checkout e o aviso de cashback
 *     continuam sendo tratados pelo pl-cart-minimum-order.js (Section
 *     Rendering API), que reage a chamada /cart/change.js normalmente.
 *   - Fix de clique duplo: o componente pai (product-quantity)
 *     intercepta o clique antes dele chegar no nosso <input>, exigindo
 *     2 cliques para focar. Interceptamos na fase de CAPTURA (antes da
 *     fase de bolha onde o bundle escuta) e paramos a propagacao,
 *     deixando o navegador focar o input normalmente no 1o clique.
 *   - ERRO DA API (422 de estoque, medido em 23/08): a Shopify TRAVA a
 *     linha no maximo disponivel E responde 422 (pediu 9999 com 1 no
 *     carrinho -> 422 e carrinho com 30). Voltar a tela para a quantidade
 *     antiga, como a v1 fazia, deixava tela 1 / carrinho 30 ate o checkout.
 *     Agora todo erro ressincroniza com /cart.js, mostra a mensagem da
 *     Shopify no toast do tema (<alert-component>, o mesmo do bundle) e
 *     guarda o maximo por item: toques seguintes no "+" e digitacao acima
 *     do maximo nao chegam na API. Sem isso, cada toque sem resposta virava
 *     mais um 422 (22-23/08: 10 em um minuto -> throttle 429 da Shopify).
 *   - FILA DE INTENCAO (medido em 27/08 — reclamacao de "delay enorme"): o
 *     /cart/change.js sozinho ja leva 550-800ms na loja. Ate 27/08, um clique
 *     durante esse tempo era DESCARTADO (busyKeys[key] retornava cedo sem
 *     guardar nada) — 3 cliques em 300ms viravam 1 requisicao e a quantidade
 *     final ficava errada (medido: +3 esperado, +1 real). pendingQty guarda
 *     a intencao mais recente e o proprio fluxo da requisicao em voo a
 *     dispara em seguida (fireCartChange), sem depender de um timer novo.
 *     Uma rajada de cliques agora sempre converge para o numero certo, com
 *     no maximo 2 requisicoes (nunca uma por clique).
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__plCartQuantityInputInit) return;
  window.__plCartQuantityInputInit = true;

  var INPUT_SELECTOR = '.product-quantity__input';
  var busyKeys = {}; // ha uma /cart/change.js em voo para esta variante agora
  var pendingQty = {}; // data-key -> ultima quantidade que o usuario pediu, pode
  // estar A FRENTE do que a API ja confirmou. Existe para nao perder clique:
  // 3 toques no "+" em 500ms, com so uma resposta chegando nesse intervalo,
  // faziam so o 1o toque valer (medido ao vivo em 27/08: 3 cliques -> 1
  // request -> quantidade final errada). Ver fireCartChange().
  var knownMax = {}; // data-key -> maximo aprendido no 1o 422 de estoque (zera no reload)
  var knownMaxMsg = {}; // data-key -> mensagem da Shopify para esse maximo
  var MSG_MAX = 'Estoque insuficiente para essa quantidade.';
  var MSG_FAIL = 'Não foi possível atualizar a quantidade. Tente novamente.';

  function isQtyInput(el) {
    return el && el.matches && el.matches(INPUT_SELECTOR);
  }

  // Base para o proximo +/-/digitacao: prefere a intencao pendente do usuario
  // (ainda nao confirmada pela API) sobre o data-quantity, que so atualiza
  // quando uma resposta chega. Sem isto, clicar duas vezes rapido calculava
  // sempre a partir do mesmo numero antigo (currentQty+1 duas vezes = +1 real).
  function getBaseQty(quantityEl, key) {
    if (pendingQty[key] != null) return pendingQty[key];
    return parseInt(quantityEl.getAttribute('data-quantity'), 10) || 0;
  }

  function getCartComponent() {
    return document.querySelector('cart-component');
  }

  function updateHeaderCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    var els = document.querySelectorAll('.header__icon--cart-count, .header__icon--cart-bullet');
    els.forEach(function (el) {
      if (/\d+/.test(el.textContent)) {
        el.textContent = el.textContent.replace(/\d+/, cart.item_count);
      } else {
        el.textContent = cart.item_count;
      }
    });
  }

  // Toast do proprio tema: <alert-component>, o mesmo que o bundle usa em
  // T.loadMessage ("Estoque insuficiente", "Erro ao atualizar"). O snippet
  // alert.liquid so e renderizado na pagina do carrinho — na PDP (onde a
  // gaveta abre depois do "Comprar") ele nao existe e nem o bundle consegue
  // avisar nada. O custom element e o CSS (fixo, embaixo, z-index maximo)
  // sao globais, entao basta criar o elemento: ao entrar no DOM o bundle o
  // adota como instancia e o toast nativo passa a funcionar ali tambem.
  // textContent, nunca HTML.
  function showMessage(text, ms) {
    var el = document.querySelector('alert-component');
    if (!el) {
      el = document.createElement('alert-component');
      el.setAttribute('hidden', '');
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.removeAttribute('hidden');
    clearTimeout(showMessage.timer);
    showMessage.timer = setTimeout(function () { el.setAttribute('hidden', ''); }, ms || 4000);
  }

  function findLine(cart, key) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.key === key || String(it.variant_id) === String(key)) return it;
    }
    return null;
  }

  // Tira a linha do item da tela quando ela zera. Sem isto o item sai do
  // carrinho de verdade (a API ja respondeu) mas a linha fica na tela
  // marcando 0 — foi o que aconteceu com a lixeira na primeira versao.
  //
  // O estado de carrinho vazio NAO precisa de reload nem de section render:
  // o CSS do bundle usa :not(:has(.cart-item)), entao tirar o ultimo
  // <cart-item> do DOM ja revela o .cart-empty e esconde checkout e LIMPAR.
  // Medido na loja em 26/08: display do .cart-empty vai de none para block, e
  // o cart-checkout de flex para none, no mesmo instante do remove().
  //
  // ⚠️ Duas chaves diferentes, nao trocar: o <product-quantity> carrega o
  // data-key da VARIANTE (44782108540998) e o <cart-item> em volta carrega a
  // chave da LINHA (44782108540998:feef3775...). O Map interno do
  // cart-items-list e indexado pela chave da LINHA.
  function removeRow(quantityEl) {
    var row = quantityEl.closest('cart-item');
    if (!row) return;
    // cart-items-list so existe na gaveta, nao na pagina /cart. Onde ele
    // existe, o metodo dele tambem apaga a entrada do Map interno — sem
    // isso o bundle continuaria achando que a linha esta la.
    var list = row.closest('cart-items-list');
    var lineKey = row.getAttribute('data-key');
    if (list && lineKey && typeof list.removeItemElement === 'function') {
      list.removeItemElement(lineKey);
      return;
    }
    row.classList.add('cart-item--removing'); // mesma classe de saida do bundle
    row.remove();
  }

  // Aplica um carrinho (resposta do change.js ou /cart.js) na tela: linha,
  // memoria interna do bundle, totais (subtotal, Pix, barra de frete) e
  // contador do header. E a UNICA forma de a tela refletir o carrinho real.
  function applyCart(cart, quantityEl, inputEl, key) {
    var line = findLine(cart, key);
    var qty = line ? line.quantity : 0;
    quantityEl.setAttribute('data-quantity', qty);
    quantityEl.currentQuantity = qty; // memoria do bundle (ver nota no topo)
    // So escreve no campo se nao ha uma intencao mais nova esperando: esta
    // resposta pode ser de um pedido de quantidade que o usuario ja superou
    // clicando de novo enquanto ela estava em voo (ver pendingQty). Escrever
    // aqui sem essa checagem faria o numero PISCAR de volta por um instante.
    if (inputEl && (pendingQty[key] == null || pendingQty[key] === qty)) setInputValue(inputEl, qty);
    var comp = getCartComponent();
    if (comp && typeof comp.updateUI === 'function') {
      try { comp.updateUI(cart); } catch (e) {}
    }
    // NAO chamar comp.renderCartItems(cart) aqui (ver nota no topo).
    updateHeaderCount(cart);
    if (qty === 0) removeRow(quantityEl);
    return qty;
  }

  // Instrumentacao sem dado pessoal: console + dataLayer (GTM decide o
  // destino). O Cloudflare so enxerga o status; aqui fica o motivo.
  function reportError(info) {
    console.warn('[pl-cart-quantity-input] /cart/change.js falhou:', info);
    try {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'pl_cart_error',
        endpoint: '/cart/change.js',
        status: info.status,
        message: info.message || '',
        variant_id: info.key,
        quantity_requested: info.requested,
        quantity_real: info.real
      });
    } catch (e) {}
  }

  function setInputValue(inputEl, value) {
    if (inputEl.tagName === 'INPUT') {
      inputEl.value = value;
    } else {
      inputEl.textContent = value;
    }
  }

  function getInputValue(inputEl) {
    var raw = inputEl.tagName === 'INPUT' ? inputEl.value : inputEl.textContent;
    return parseInt(String(raw).replace(/\D/g, ''), 10);
  }

  // Decide SE vale a pena mudar e registra a intencao em pendingQty. Nao
  // fala com a rede diretamente — quem faz isso e fireCartChange(), chamada
  // aqui embaixo so quando nao ha requisicao em voo para esta variante.
  // Se ja houver (busyKeys[key]), a intencao fica guardada e e' o .then()
  // final da requisicao em voo (dentro de fireCartChange) quem a pega depois.
  // E assim, uma rajada de cliques vira NO MAXIMO 2 requisicoes (a que ja
  // estava em voo + 1 com o valor final), nunca uma por clique nem cliques
  // perdidos.
  function commitQuantityValue(quantityEl, inputEl, currentQty, newQty) {
    var key = quantityEl.getAttribute('data-key');

    if (isNaN(newQty) || newQty < 0) {
      if (inputEl) setInputValue(inputEl, currentQty);
      return;
    }

    if (newQty === currentQty) {
      if (inputEl) setInputValue(inputEl, currentQty);
      return;
    }

    // Maximo ja conhecido para este item: trava aqui, sem ir na API.
    if (knownMax[key] != null && newQty > knownMax[key]) {
      showMessage(knownMaxMsg[key] || MSG_MAX);
      newQty = knownMax[key];
      if (newQty === currentQty) {
        if (inputEl) setInputValue(inputEl, currentQty);
        return;
      }
      if (inputEl) setInputValue(inputEl, newQty);
    }

    pendingQty[key] = newQty;

    if (busyKeys[key]) return; // o .then() final da requisicao em voo cuida disto
    fireCartChange(quantityEl, inputEl, key);
  }

  // Dispara /cart/change.js com o valor MAIS RECENTE de pendingQty (nao um
  // valor capturado antes) — se o usuario clicou de novo enquanto a
  // requisicao anterior ainda respondia, e' esse valor mais novo que sai
  // daqui, nunca um intermediario.
  function fireCartChange(quantityEl, inputEl, key) {
    var newQty = pendingQty[key];
    if (newQty == null) return;

    // Ultimo valor confirmado pela API — usado so como fallback de reversao
    // se o /cart.js de resincronia tambem falhar.
    var beforeQty = parseInt(quantityEl.getAttribute('data-quantity'), 10) || 0;

    busyKeys[key] = true;
    if (inputEl) inputEl.setAttribute('disabled', 'disabled');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (res) {
        if (res.ok) return res.json();
        // Corpo do erro da Shopify: {status, message, description}.
        return res.json().catch(function () { return {}; }).then(function (body) {
          var err = new Error('change.js ' + res.status);
          err.status = res.status;
          err.body = body || {};
          throw err;
        });
      })
      .then(function (cart) {
        return applyCart(cart, quantityEl, inputEl, key);
      })
      .catch(function (err) {
        var status = err && err.status;
        var body = (err && err.body) || {};
        var message = body.description || body.message || '';
        // 429 = throttle da Shopify: nao insistir nem com /cart.js.
        var resync = status && status !== 429
          ? fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; })
          : Promise.resolve(null);
        return resync.then(function (cart) {
          var real = beforeQty;
          if (cart) {
            real = applyCart(cart, quantityEl, inputEl, key);
          } else if (inputEl && (pendingQty[key] == null || pendingQty[key] === beforeQty)) {
            setInputValue(inputEl, beforeQty);
          }
          if (status === 422 && real < newQty) {
            knownMax[key] = real;
            knownMaxMsg[key] = message;
          }
          // Sem isto, um pendingQty que pediu alem do maximo recem-aprendido
          // reenfileiraria a MESMA quantidade recusada no .then() final —
          // loop de 422 a cada resposta.
          //
          // 04/09: o MESMO problema tambem acontecia no 429 (throttle da
          // Shopify), so que na direcao contraria — decremento/remocao
          // rejeitado. "> real" nunca e verdadeiro pra um valor MENOR que
          // o real, entao pendingQty ficava intacto e o .then() final
          // disparava fireCartChange de novo, na hora, com a MESMA
          // quantidade recem-recusada — sem nenhuma espera. Sob conexao
          // lenta isso virava rajada continua de /cart/change.js (medido:
          // um unico cliente com 4.404 chamadas numa janela).
          //
          // Corrige comparando com newQty (o valor que ACABOU de falhar),
          // nao com "maior que real": se pendingQty ainda for exatamente
          // o valor recusado (ninguem clicou de novo durante o voo),
          // sincroniza pra real e cancela o retry automatico — clique
          // novo do usuario cria uma intencao nova e tenta de novo depois.
          // Se pendingQty ja for outro valor (clique novo chegou durante
          // a espera), e uma intencao legitima e diferente: deixa passar,
          // o .then() final tenta ELA, nao a que falhou.
          if (pendingQty[key] === newQty) {
            pendingQty[key] = real;
          }
          showMessage(message || MSG_FAIL);
          reportError({ status: status, message: message, key: key, requested: newQty, real: real });
          return real;
        });
      })
      .then(function (confirmedQty) {
        busyKeys[key] = false;
        if (inputEl) inputEl.removeAttribute('disabled');
        if (pendingQty[key] != null && pendingQty[key] !== confirmedQty) {
          fireCartChange(quantityEl, inputEl, key); // intencao mais nova chegou durante o voo
        } else {
          delete pendingQty[key];
        }
      });
  }

  function commitQuantity(inputEl) {
    var quantityEl = inputEl.closest('product-quantity');
    if (!quantityEl) return;
    var key = quantityEl.getAttribute('data-key');
    var currentQty = getBaseQty(quantityEl, key);
    var newQty = getInputValue(inputEl);
    commitQuantityValue(quantityEl, inputEl, currentQty, newQty);
  }

  // ------------------------------------------------------------
  // Assume o controle TOTAL dos botoes +/-, impedindo que o clique
  // chegue no listener proprio do bundle. Motivo: o bundle guarda a
  // quantidade numa variavel interna PROPRIA (na memoria do
  // componente), separada do atributo data-quantity do HTML. Quando
  // o cliente digita um valor e nos atualizamos so o atributo, a TELA
  // fica certa mas a MEMORIA do bundle continua com o valor antigo —
  // ao clicar em +/-, o bundle usa a memoria dele (errada), causando
  // divergencia (ex: digitou 5, clicou em "-", bundle calcula a partir
  // do 15 antigo e mostra 14). Processando +/- nos mesmos, sempre a
  // partir do data-quantity atual (nossa unica fonte de verdade,
  // sempre confirmada pela resposta real da API), essa divergencia
  // deixa de ser possivel.
  // ------------------------------------------------------------
  function isQtyButton(el) {
    return el && el.closest && el.closest('.product-quantity__button');
  }

  document.addEventListener('mousedown', function (e) {
    if (isQtyButton(e.target)) e.stopPropagation();
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-quantity__button');
    if (!btn) return;

    e.stopPropagation();
    e.preventDefault();

    var quantityEl = btn.closest('product-quantity');
    if (!quantityEl) return;

    var isIncrement = btn.classList.contains('product-quantity__button--increment');
    var key = quantityEl.getAttribute('data-key');
    var currentQty = getBaseQty(quantityEl, key);
    if (isIncrement && knownMax[key] != null && currentQty >= knownMax[key]) {
      showMessage(knownMaxMsg[key] || MSG_MAX);
      return;
    }
    var newQty = isIncrement ? currentQty + 1 : Math.max(0, currentQty - 1);

    var inputEl = quantityEl.querySelector(INPUT_SELECTOR);
    if (inputEl) setInputValue(inputEl, newQty); // feedback visual imediato

    commitQuantityValue(quantityEl, inputEl, currentQty, newQty);
  }, true);

  // ------------------------------------------------------------
  // Lixeira: remove so o item da propria linha, setando a quantidade
  // para 0. Mesmo caminho do +/- (commitQuantityValue -> /cart/change.js),
  // sem endpoint ou fluxo separado — herda o tratamento de 422, o busy
  // lock por chave e a ressincronia que ja existem ali.
  // ------------------------------------------------------------
  document.addEventListener('mousedown', function (e) {
    if (e.target.closest && e.target.closest('[data-remove-item]')) e.stopPropagation();
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-remove-item]');
    if (!btn) return;

    e.stopPropagation();
    e.preventDefault();

    var quantityEl = btn.closest('product-quantity');
    if (!quantityEl) return;

    var key = quantityEl.getAttribute('data-key');
    var currentQty = getBaseQty(quantityEl, key);
    if (currentQty === 0) return;

    var inputEl = quantityEl.querySelector(INPUT_SELECTOR);
    if (inputEl) setInputValue(inputEl, 0); // feedback visual imediato

    commitQuantityValue(quantityEl, inputEl, currentQty, 0);
  }, true);

  // ------------------------------------------------------------
  // Fix de clique duplo: intercepta na fase de captura para que o
  // navegador foque o input ja no primeiro clique.
  // ------------------------------------------------------------
  document.addEventListener('mousedown', function (e) {
    if (isQtyInput(e.target)) e.stopPropagation();
  }, true);

  document.addEventListener('click', function (e) {
    if (isQtyInput(e.target)) e.stopPropagation();
  }, true);

  // ------------------------------------------------------------
  // Digitar + confirmar (Enter ou blur)
  // ------------------------------------------------------------
  document.addEventListener('keydown', function (e) {
    if (!isQtyInput(e.target)) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.blur();
    }
  });

  document.addEventListener('blur', function (e) {
    if (!isQtyInput(e.target)) return;
    commitQuantity(e.target);
  }, true);

  document.addEventListener('focus', function (e) {
    if (!isQtyInput(e.target)) return;
    if (e.target.tagName === 'INPUT') {
      setTimeout(function () { e.target.select(); }, 0);
    }
  }, true);

  // ------------------------------------------------------------
  // "Curador": o bundle desenha a linha do carrinho pelo TEMPLATE
  // INTERNO dele (Y.render -> renderQuantity), que nao conhece nada
  // nosso. Toda linha criada no cliente — item adicionado com a gaveta
  // aberta, gaveta montada depois do "Comprar" na PDP — nasce assim:
  //
  //   <product-quantity class='product-quantity'>
  //     <button data-action='decrement'>   <span class='product-quantity__input'>
  //     <button data-action='increment'>
  //
  // Sem o <input>, sem o .product-quantity__stepper e sem a lixeira.
  //
  // 🚨 Isso NAO e so falta de funcionalidade, e quebra VISUAL: o CSS do
  // _cart-item.liquid zera a pilula do bundle no <product-quantity>
  // (border/padding/max-width, ver o commit do overflow) e passa a borda
  // para o .product-quantity__stepper. Numa linha criada pelo bundle esse
  // stepper nao existe, entao nao sobra borda nenhuma e o controle aparece
  // "pelado" — some so depois de um F5, que faz o Liquid redesenhar tudo.
  // Era exatamente este o sintoma relatado em 26/08.
  //
  // O CSS nunca foi o problema: o {% style %} do bloco e emitido em toda
  // pagina que tem a gaveta, mesmo com o carrinho vazio (medido na PDP e
  // na /cart, 8 regras presentes com item_count 0). Faltava so o markup.
  //
  // Por isso o curador normaliza a ESTRUTURA inteira, nao so o <input>.
  // E idempotente: em linha vinda do Liquid tudo ja existe e ele nao toca.
  // Usa debounce curto para nao rodar a cada micro-mutacao do DOM.
  // ------------------------------------------------------------
  var healScheduled = false;

  function healInput(qtyEl) {
    var current = qtyEl.querySelector(INPUT_SELECTOR);
    if (!current || current.tagName === 'INPUT') return; // ja e input

    var value = current.textContent.trim();
    var input = document.createElement('input');
    input.type = 'number';
    input.setAttribute('inputmode', 'numeric');
    input.min = '0';
    input.value = value;
    input.className = 'product-quantity__input';
    input.setAttribute('aria-label', 'Quantidade');
    current.replaceWith(input);
  }

  // Envolve -/campo/+ no .product-quantity__stepper, que e quem carrega a
  // borda depois que o CSS zerou a pilula do bundle.
  function healStepper(qtyEl) {
    if (qtyEl.querySelector('.product-quantity__stepper')) return; // ja tem

    var dec = qtyEl.querySelector('.product-quantity__button--decrement');
    var inc = qtyEl.querySelector('.product-quantity__button--increment');
    var field = qtyEl.querySelector(INPUT_SELECTOR);
    if (!dec || !inc || !field) return; // estrutura inesperada: nao mexe

    var stepper = document.createElement('span');
    stepper.className = 'product-quantity__stepper';
    dec.parentNode.insertBefore(stepper, dec);
    stepper.appendChild(dec);
    stepper.appendChild(field);
    stepper.appendChild(inc);
  }

  // Lixeira. O simbolo #pl-i-trash vem do pl-icon-sprite, renderizado no
  // theme.liquid — existe em toda pagina, entao o use resolve sempre.
  function healRemoveButton(qtyEl) {
    if (qtyEl.querySelector('[data-remove-item]')) return; // ja tem

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-remove-item', '');
    btn.className = 'product-quantity__remove';
    btn.setAttribute('aria-label', 'Remover item do carrinho');
    btn.setAttribute('title', 'Remover item');
    btn.innerHTML = "<svg width='16' height='16' viewBox='0 0 18 18' fill='none' aria-hidden='true'><use href='#pl-i-trash'/></svg>";
    qtyEl.insertBefore(btn, qtyEl.firstChild); // antes do stepper, a esquerda
  }

  function healQuantityInputs() {
    healScheduled = false;
    document.querySelectorAll('product-quantity').forEach(function (qtyEl) {
      healInput(qtyEl);
      // Lixeira e stepper so no carrinho: a PDP tambem tem product-quantity,
      // e la nao existe linha para remover.
      if (!qtyEl.closest('cart-item')) return;
      healStepper(qtyEl);
      healRemoveButton(qtyEl);
    });
  }

  function scheduleHeal() {
    if (healScheduled) return;
    healScheduled = true;
    requestAnimationFrame(healQuantityInputs);
  }

  function initHealObserver() {
    // Prefere observar so a area do carrinho (mais leve). Cai para
    // document.body como fallback se o componente ainda nao existir
    // no momento do load.
    var scopeEl = document.querySelector('cart-component') || document.body;

    var observer = new MutationObserver(function () {
      // Sem filtro fino aqui: quando o bundle redesenha um item do
      // carrinho, ele costuma substituir o <cart-item> INTEIRO (nao so
      // o campo de quantidade), entao a mutacao aparece no CONTAINER
      // pai da lista, nao dentro do product-quantity em si — um filtro
      // que procurasse ancestral (.closest) nunca bateria. Mais simples
      // e robusto: agenda a cura em qualquer mutacao no escopo; a
      // funcao em si e barata (retorna cedo se ja for <input>).
      scheduleHeal();
    });

    observer.observe(scopeEl, { childList: true, subtree: true });

    // roda uma vez no load tambem, caso a pagina ja carregue com spans
    scheduleHeal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHealObserver);
  } else {
    initHealObserver();
  }
})();